<template>
  <div class="add-record" v-show="isLimit">
    <div class="title flex-between">
      <h3>快速跟单</h3>
    </div>
    <van-form @submit="onSubmit">
      <div class="f-required">
        <van-field readonly clickable :value="typedname" name="type" label="学员类型：" placeholder="请选择" @click="showPicker = true" />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker show-toolbar :columns="columnsType" value-key="dname" @confirm="onConfirmStudentType" @cancel="showPicker = false" />
        </van-popup>
      </div>
      <div class="f-required stu-form-item">
        <i @click="showMess = true" class="el-icon-question quest-icon"></i>
        <van-field
          readonly
          required
          clickable
          :value="studentZhiLiang"
          name="type"
          label="学员质量："
          placeholder="请选择"
          @click="showPickerZhiLiang = true"
          :rules="[{ required: true, message: '请选择学员质量', trigger: 'blur' }]"
        />
        <van-popup v-model="showPickerZhiLiang" position="bottom">
          <van-picker show-toolbar :columns="columnsZhiLiang" value-key="dname" @confirm="onConfirmZhiLiang" @cancel="showPickerZhiLiang = false" />
        </van-popup>
      </div>
      <div class="f-required">
        <van-field
          readonly
          required
          clickable
          :value="firstLevelName"
          name="type"
          label="一级分类："
          placeholder="请选择"
          @click="showPickerFirstLevel = true"
          :rules="[{ required: true, message: '请选择一级分类', trigger: 'blur' }]"
        />
        <van-popup v-model="showPickerFirstLevel" position="bottom">
          <van-picker show-toolbar :columns="firstLevel" value-key="typeName" @confirm="onConfirmFirstLevel" @cancel="showPickerFirstLevel = false" />
        </van-popup>
      </div>
      <div class="f-required">
        <van-field readonly clickable :value="secondLevelName" name="type" label="二级分类：" placeholder="请选择" @click="openSecondLevel" />
        <van-popup v-model="showPickerSecondLevel" position="bottom">
          <van-picker show-toolbar :columns="secondLevel" value-key="typeName" @confirm="onConfirmSecondLevel" @cancel="showPickerSecondLevel = false" />
        </van-popup>
      </div>
      <div class="f-required">
        <van-field readonly clickable :value="thirdLevelName" name="type" label="三级分类：" placeholder="请选择" @click="openThirdLevel" />
        <van-popup v-model="showPickerThirdLevel" position="bottom">
          <van-picker show-toolbar :columns="thirdLevel" value-key="typedname" @confirm="onConfirmThirdLevel" @cancel="showPickerThirdLevel = false" />
        </van-popup>
      </div>
      <van-field readonly clickable name="nexttracetime" :value="nexttracetime" label="下次跟单时间：" placeholder="点击选择日期" @click="nextCalendar = true" />
      <!--  -->
      <van-calendar v-model="nextCalendar" @confirm="nextonConfirm" color="#277FFF" />
      <van-field readonly clickable name="planstudytime" :value="planstudytime" label="预计学习时间：" placeholder="点击选择日期" @click="planCalendar = true" />
      <!--  -->
      <van-calendar v-model="planCalendar" @confirm="dateonConfirm" color="#277FFF" />
      <div class="f-required">
        <!-- <b class="second-icon">❊</b> -->
        <van-field
          v-model="remark"
          required
          maxlength="300"
          show-word-limit
          rows="5"
          name="remark"
          label="跟单内容："
          placeholder="请输入跟单内容(不支持表情包)"
          type="textarea"
          :rules="[{ required: true, message: '请填写跟单内容' }]"
        />
      </div>
      <div class="submit-btn">
        <van-button block type="info" native-type="submit">确定</van-button>
      </div>
    </van-form>
    <van-dialog v-model="showMess" title="学员质量规则">
      <div class="show-quality">
        <p>
          <span class="qe-title"> A量：</span>
          <span class="qe-text">了解培训/接受学习/学习意向量/年龄学历相符；</span>
        </p>
        <p>
          <span class="qe-title"> B量：</span>
          <span class="qe-text">有转行想法/有学习规划/正在了解或学习相关视频 ；</span>
        </p>

        <p><span class="qe-title"> C量：</span><span class="qe-text">已建立联系/不排斥沟通/需要长期影响（已加微信/QQ）/低年级大学生；</span></p>
        <p><span class="qe-title"> D量：</span><span class="qe-text">暂时联系不上/无效联系方式/排斥培训/排斥沟通/广告商/骂人的/年龄不符/无千锋相关学科且学科跨度大/竞品；</span></p>
        <p>注：学员只能从D量往A量升级，不能降级</p>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import quickOrder from "@/views/studentInfo/js/quickOrder.js";
export default quickOrder;
</script>
<style scoped lang="less">
@import "css/addRecord";
</style>
